import React, { useEffect, useState } from "react";
import { FxmsData } from "../../fxms/datas/FxData";
import { FxWindow } from "./../../fxms/windows/FxWindows";
import { getDay, getInloInfo, getMonthBetween } from "../common/commonMethod";
import UI_3_5_ChartLine from "./UI_3_5_ChartLine";
import UI_3_5_ChartScatter from "./UI_3_5_ChartScatter";
import Button from "@mui/material/Button";
import { FxOpenButton } from "./../../fxms/inputs/FxOpenButton";
import { DateUtil } from "../../fxms/datas/DateUtil";

/**
 * @description 설비진단 > 예지정비
 * @author SONJIEUN
 * @date 01/08/2025
 * @param {*}
 * @return  설비진단 > 예지정비
 */

export const UI_3_5 = (props) => {
  const user = FxmsData.getUser();
  const inlo = getInloInfo(FxmsData.getInlo(user.inloNo), user);
  const opObjAdd = FxmsData.getOpObj("ui-3-3-add"); /* 조치실적 등록 팝업 */

  const [fetchComplexInlo, setFetchComplexInlo] = useState([]);
  const [fetchCompanyInlo, setFetchCompanyInlo] = useState([]);
  const [fetchPlantInlo, setFetchPlantInlo] = useState([]);
  const [fetchFacList, setFetchFacList] = useState([]);
  const [fetchDataState, setFetchDataState] = useState([]); /* 센서진단 */
  const [fetchDataGraph, setFetchDataGraph] = useState(
    []
  ); /* 운전패턴진단 전체체(그래프) */
  const [selectedFacInfo, setSelectedFacInfo] = useState([]);
  const [selectedTagGraphData, setSelectedTagGraphData] = useState([]);
  const [chartLineYn, setChartLineYn] = useState(true);
  const [selected, setSelected] = useState({
    facNo: "",
    //today : '20250110', /*테스트 데이터_시화도금단지-공압기#2와 인천표면처리센터-보일러#1*/
    today: getDay(0),
  });
  const [alarmData, setAlarmData] = useState("");

  useEffect(() => {
    console.log("*** UI_3_5 ***");

    if (user.ugrpNo === 1021) {
      //산단
      selectedComplex(inlo.complexInloNo);
    } else {
      //vup (107)
      getComplexInloData();
    }
  }, [inlo, user]);

  useEffect(() => {
    if (inlo.complexInloNo && user.ugrpNo !== 1024) {
      selectedComplex(inlo.complexInloNo);
    }
  }, [selected.method, selected.engId]);

  const getComplexInloData = async () => {
    const uri = "vup/getComplexInloList";
    try {
      const res = await FxmsData.GET(uri);
      const complexlist = res.data.filter(x => (x.inloName === "시화도금단지" || x.inloName === "인천표면처리센타"));

      setFetchComplexInlo(complexlist);
      console.log("complex List >> ", complexlist);
      
    } catch (e) {
      console.log("getComplexInloList error ........", e);
    }
  };
  const selectedComplex = async (value) => {
    console.log("선택된 산단번호 ::", value);

    if (value === "" || !value) {
      setFetchCompanyInlo([]);
      setFetchPlantInlo([]);
      setFetchFacList([]);
      setSelectedFacInfo([]);
      setSelected((prev) => ({ ...prev, facNo: "" }));
    } else {
      console.log("선택된 산단번호 ::", value);
      const uri = "vup/getCompanyInloList/" + value;

      try {
        const res = await FxmsData.GET(uri);
        const company = res.data.filter((x) => x.inloName === "조합공용");
        if (company.length !== 0) {
          setFetchCompanyInlo(company[0]);
          selectedCompany(company[0].inloNo);
          console.log("company List >>", res.data);
        } else {
          setFetchCompanyInlo([]);
          setFetchPlantInlo([]);
          setFetchFacList([]);
          setSelectedFacInfo([]);
          setFetchDataState([]);
          setFetchDataGraph([]);
          setSelectedTagGraphData([]);
          setAlarmData("");
        }
      } catch (e) {
        console.log("getCompanyInloList error.... ", e);
      }
    }
    console.log("selected ........", selected);
  };

  const selectedCompany = async (value) => {
    if (value === "") {
      setFetchPlantInlo([]);
      setFetchFacList([]);
      setSelected((prev) => ({ ...prev, facNo: value }));
    } else {
      const uri = "vup/getPlantInloList/" + value;
      try {
        const res = await FxmsData.GET(uri);
        setFetchPlantInlo(res.data[0]);
        selectedPlant(res.data[0].inloNo);
        console.log("plant List >>", res.data);
      } catch (e) {
        console.log("getPlantInloList error.... ", e);
      }
    }
    setFetchFacList([]);
  };

  const selectedPlant = async (value) => {
    if (value === "") {
      setSelected((prev) => ({ ...prev, facNo: value }));
      setFetchFacList([]);
      return;
    } else {
      const uri = "vup/getFacNoList3_5/" + value;
      try {
        const res = await FxmsData.GET(uri);
        setFetchFacList(res.data);
        
        if (res.data.length !== 0) {
          setSelected((prev) => ({ ...prev, facNo: res.data[0].facNo }));
          setSelectedFacInfo(res.data[0]);
          getDataState(res.data[0].facNo);
          getFacAlarm(res.data[0].facNo);
          getFacGraphData(res.data[0].facNo);

          if (res.data[0].facType === "Compressor") setChartLineYn(true);
        }
        console.log("fac List >> ", fetchFacList);
      } catch (e) {
        console.log("getFacNoList error ........", e);
      }
    }
  };

  const onChangeDatas = (event) => {
    const { value, name } = event.target;

    setSelected((prev) => {
      return { ...prev, [name]: value };
    });

    if (name === "facNo") {
      const fac = fetchFacList.filter((x) => x.facNo == value)[0];
      setSelectedFacInfo(fac);

      // API 호출 해당 설비 정보 , 알람정보, 수명예측 조회// 모든 데이터 버튼으로 변경해야함-전력 LNG O2 외 급수 스팀 등
      getDataState(value);
      getFacGraphData(value);
      getFacAlarm(value);
    }
  };

  const getDataState = async (value) => {
    if (selected == null) return;

    const param = {
      facNo: value,
      today: selected.today.replace(/-/gi, ""),
    };

    try {
      const uri = "vup/select_3_5";
      const res = await FxmsData.GET(uri, param);
      console.log("UI_3_5 res........", res.data);

      setFetchDataState(res.data);
    } catch (e) {
      console.log("UI_3_5 fetchData error", e);
    }
  };

  const getFacGraphData = async (value) => {
    if (selected == null) return;

    const param = {
      facNo: value,
      startDate: selected.today.replace(/-/gi, ""),
      endDate: selected.today.replace(/-/gi, ""),
    };

    try {
      const uri = "vup/select_3_5_graph";
      const res = await FxmsData.GET(uri, param);
      console.log("UI_3_5 res........", res.data);

      setFetchDataGraph(res.data);
      if (res.data.length > 0) {
        if (res.data[0].engId === "AIR") {
          makeGraphData("소비전력", res.data);
        }
        if (res.data[0].engId === "STEAM") {
          makeGraphData("LNG 투입량", res.data);
        }
      } else {
        setSelectedTagGraphData([]);
      }
    } catch (e) {
      console.log("UI_3_5 fetchData error", e);
    }
  };

  const getFacAlarm = async (value) => {
    if (selected == null) return;

    const param = {
      facNo: value,
      today: selected.today.replace(/-/gi, ""),
    };

    try {
      const uri = "vup/select_3_5_alarm";
      const res = await FxmsData.GET(uri, param);
      console.log("UI_3_5 res........", res.data);

      if (!res.data.hasOwnProperty("alarmFpactCnts")) setAlarmData(res.data);
    } catch (e) {
      console.log("UI_3_5 fetchData error", e);
    }
  };

  const makeGraphData = (tag, init) => {
    setChartLineYn(true);
    const s = {};
    s.name = tag;
    s.type = "line";
    s.data = [];

    switch (tag) {
      case "소비전력":
        for (const data of init || fetchDataGraph) {
          s.data.push([
            DateUtil.makeDate(data.regDtm).getTime(),
            data.elecConsVal,
          ]);
        }
        break;
      case "흡입온도":
        for (const data of fetchDataGraph) {
          s.data.push([
            DateUtil.makeDate(data.regDtm).getTime(),
            data.tempInputVal,
          ]);
        }
        break;
      case "흡입압력":
        for (const data of fetchDataGraph) {
          s.data.push([
            DateUtil.makeDate(data.regDtm).getTime(),
            data.pressInputVal,
          ]);
        }
        break;
      case "토출온도":
        for (const data of fetchDataGraph) {
          s.data.push([
            DateUtil.makeDate(data.regDtm).getTime(),
            data.tempStepVal,
          ]);
        }
        break;
      case "토출압력":
        for (const data of fetchDataGraph) {
          s.data.push([
            DateUtil.makeDate(data.regDtm).getTime(),
            data.pressStepVal,
          ]);
        }
        break;
      case "유량":
        for (const data of fetchDataGraph) {
          s.data.push([
            DateUtil.makeDate(data.regDtm).getTime(),
            data.airOutputVal,
          ]);
        }
        break;
      case "LNG 투입량":
        for (const data of init || fetchDataGraph) {
          s.data.push([
            DateUtil.makeDate(data.regDtm).getTime(),
            data.lngInputVal,
          ]);
        }
        break;
      case "급수유량":
        for (const data of fetchDataGraph) {
          s.data.push([
            DateUtil.makeDate(data.regDtm).getTime(),
            data.waterFlowVal,
          ]);
        }
        break;
      case "급수온도":
        for (const data of fetchDataGraph) {
          s.data.push([
            DateUtil.makeDate(data.regDtm).getTime(),
            data.waterTempVal,
          ]);
        }
        break;
      case "스팀유량":
        for (const data of fetchDataGraph) {
          s.data.push([
            DateUtil.makeDate(data.regDtm).getTime(),
            data.steamFlowVal,
          ]);
        }

        break;
      case "스팀온도":
        for (const data of fetchDataGraph) {
          s.data.push([
            DateUtil.makeDate(data.regDtm).getTime(),
            data.steamTempVal,
          ]);
        }
        break;
      case "스팀압력":
        for (const data of fetchDataGraph) {
          s.data.push([
            DateUtil.makeDate(data.regDtm).getTime(),
            data.steamPressVal,
          ]);
        }
        break;
      case "배기가스온도":
        for (const data of fetchDataGraph) {
          s.data.push([
            DateUtil.makeDate(data.regDtm).getTime(),
            data.exGasTempVal,
          ]);
        }
        break;
      case "O2농도":
        s.xy = [fetchDataState.xO2, fetchDataState.yCo];
        s.targetO2 = fetchDataState.targetO2;
        s.targetCo = fetchDataState.targetCo;
        s.limit = fetchDataState.scatterLimit;

        var arrayO2 = fetchDataState.arrayO2.split(",");
        var arrayCo = fetchDataState.arrayCo.split(",");

        for (let key in arrayO2) {
          s.data.push([Number(arrayO2[key]), Number(arrayCo[key])]);
        }

        setChartLineYn(false);

        break;
      case "CO농도":
        s.xy = [fetchDataState.xO2, fetchDataState.yCo];
        s.targetO2 = fetchDataState.targetO2;
        s.targetCo = fetchDataState.targetCo;
        s.limit = fetchDataState.scatterLimit;

        var arrayO2 = fetchDataState.arrayO2.split(",");
        var arrayCo = fetchDataState.arrayCo.split(",");

        for (let key in arrayO2) {
          s.data.push([Number(arrayO2[key]), Number(arrayCo[key])]);
        }
        setChartLineYn(false);

        break;
      default:
        return [];
    }

    setSelectedTagGraphData(s);
  };

  const getDateHtml = (date) => {
    let textDate = date.toString();
    return (
      "(" +
      textDate.substring(0, 4) +
      "." +
      textDate.substring(4, 6) +
      "." +
      textDate.substring(6, 8) +
      " " +
      textDate.substring(8, 10) +
      ":" +
      textDate.substring(10, 12) +
      ":" +
      textDate.substring(12, 14) +
      ")"
    );
  };

  const getFacilityNowHtml = () => {
    /*TODO: Fault 값은 우원에서 API로 받아야함 현재 미개발 상태 */
    //2시간마다 현재상태 데이터 리프레시
    if (selectedFacInfo.length !== 0 && selectedFacInfo.facType !== "Compressor") {
      return (
        <>
          <div class="FxMuiTable">
            <table>
              <thead>
                <tr>
                  <th>TAG</th>
                  <th>단위</th>
                  <th>현재값</th>
                  <th>Fault</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <button onClick={(e) => makeGraphData(e.target.innerText)}>
                      LNG 투입량
                    </button>
                  </td>
                  <td>Nm3/hr</td>
                  <td>{fetchDataState.lngInputVal || 0}</td>
                  <td>
                    <span
                      class={
                        fetchDataState.lngInputFaultYn === "Y"
                          ? "fail"
                          : "success"
                      }
                    ></span>
                  </td>
                </tr>
                
                <tr>
                  <td>
                    <button onClick={(e) => makeGraphData(e.target.innerText)}>
                      스팀유량
                    </button>
                  </td>
                  <td>Kg/h</td>
                  <td>{fetchDataState.steamFlowVal || 0}</td>
                  <td>
                    <span
                      class={
                        fetchDataState.steamFlowFaultYn === "Y"
                          ? "fail"
                          : "success"
                      }
                    ></span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button onClick={(e) => makeGraphData(e.target.innerText)}>
                      스팀온도
                    </button>
                  </td>
                  <td>℃</td>
                  <td>{fetchDataState.steamTempVal || 0}</td>
                  <td>
                    <span
                      class={
                        fetchDataState.steamTempFaultYn === "Y"
                          ? "fail"
                          : "success"
                      }
                    ></span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button onClick={(e) => makeGraphData(e.target.innerText)}>
                      스팀압력
                    </button>
                  </td>
                  <td>bar</td>
                  <td>{fetchDataState.steamPressVal || 0}</td>
                  <td>
                    <span
                      class={
                        fetchDataState.steamPressFaultYn === "Y"
                          ? "fail"
                          : "success"
                      }
                    ></span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button onClick={(e) => makeGraphData(e.target.innerText)}>
                      배기가스온도
                    </button>
                  </td>
                  <td>℃</td>
                  <td>{fetchDataState.exGasTempVal || 0}</td>
                  <td>
                    <span
                      class={
                        fetchDataState.exGasTempFaultYn === "Y"
                          ? "fail"
                          : "success"
                      }
                    ></span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button onClick={(e) => makeGraphData(e.target.innerText)}>
                      O2농도
                    </button>
                  </td>
                  <td>%</td>
                  <td>{fetchDataState.conO2Val || 0}</td>
                  <td>
                    <span
                      class={
                        fetchDataState.conO2FaultYn === "Y" ? "fail" : "success"
                      }
                    ></span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button onClick={(e) => makeGraphData(e.target.innerText)}>
                      CO농도
                    </button>
                  </td>
                  <td>ppm</td>
                  <td>{fetchDataState.conCoVal || 0}</td>
                  <td>
                    <span
                      class={
                        fetchDataState.conCoFaultYn === "Y" ? "fail" : "success"
                      }
                    ></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      );
    }

    return (
      <>
        {" "}
        <div class="FxMuiTable mt20">
          <table>
            <thead>
              <tr>
                <th>TAG</th>
                <th>단위</th>
                <th>현재값</th>
                <th>Fault</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <button onClick={(e) => makeGraphData(e.target.innerText)}>
                    소비전력
                  </button>
                </td>
                <td>kW</td>
                <td>{fetchDataState.elecConsVal || 0}</td>
                <td>
                  <span
                    class={
                      fetchDataState.elecConsFaultYn === "Y"
                        ? "fail"
                        : "success"
                    }
                  ></span>
                </td>
              </tr>
              <tr>
                <td>
                  <button onClick={(e) => makeGraphData(e.target.innerText)}>
                    흡입온도
                  </button>
                </td>
                <td>℃</td>
                <td>{fetchDataState.tempInputVal || 0}</td>
                <td>
                  <span
                    class={
                      fetchDataState.tempInputFaultYn === "Y"
                        ? "fail"
                        : "success"
                    }
                  ></span>
                </td>
              </tr>
              
              <tr>
                <td>
                  <button onClick={(e) => makeGraphData(e.target.innerText)}>
                    토출온도
                  </button>
                </td>
                <td>℃</td>
                <td>{fetchDataState.tempStepVal || 0}</td>
                <td>
                  <span
                    class={
                      fetchDataState.tempStepFaultYn === "Y"
                        ? "fail"
                        : "success"
                    }
                  ></span>
                </td>
              </tr>
              <tr>
                <td>
                  <button onClick={(e) => makeGraphData(e.target.innerText)}>
                    토출압력
                  </button>
                </td>
                <td>Bar</td>
                <td>{fetchDataState.pressStepVal || 0}</td>
                <td>
                  <span
                    class={
                      fetchDataState.pressStepFaultYn === "Y"
                        ? "fail"
                        : "success"
                    }
                  ></span>
                </td>
              </tr>
              <tr>
                <td>
                  <button onClick={(e) => makeGraphData(e.target.innerText)}>
                    유량
                  </button>
                </td>
                <td>Nm3/hr</td>
                <td>{fetchDataState.airOutputVal || 0}</td>
                <td>
                  <span
                    class={
                      fetchDataState.airOutputFaultYn === "Y"
                        ? "fail"
                        : "success"
                    }
                  ></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="predict">
        <div className="FxCrudFilter">
          <div className="FxFilterLeft">
            <label className="FxLabelSearch"></label>
            {user.ugrpNo === 1021 || user.ugrpNo === 1024 ? (
              <select className="FxSelectSearch" value={inlo.complexInloNo}>
                <option value={inlo.complexInloNo}>
                  {" "}
                  {inlo.complexInloName}{" "}
                </option>
              </select>
            ) : (
              <select
                className="FxSelectSearch"
                onChange={(e) => selectedComplex(e.target.value)}
              >
                <option value="">산업단지명</option>
                {fetchComplexInlo.map((item) => (
                  <option
                    key={item.inloNo}
                    value={item.inloNo}
                    name="complexInloNo"
                  >
                    {item.inloName}
                  </option>
                ))}
              </select>
            )}
            <select className="FxSelectSearch" value={fetchCompanyInlo.inloNo}>
              {fetchCompanyInlo.length !== 0 ? (
                <option
                  key={fetchCompanyInlo.inloNo}
                  value={fetchCompanyInlo.inloNo}
                  name="companyInloNo"
                >
                  {fetchCompanyInlo.inloName}
                </option>
              ) : (
                <option value="">회사명</option>
              )}
            </select>

            <select className="FxSelectSearch" value={fetchPlantInlo.inloNo}>
              {fetchPlantInlo.length !== 0 ? (
                <option
                  key={fetchPlantInlo.inloNo}
                  value={fetchPlantInlo.inloNo}
                  name="plantInloNo"
                >
                  {fetchPlantInlo.inloName}
                </option>
              ) : (
                <option value="">사업장명</option>
              )}
            </select>
          </div>
        </div>
        <div className="FxCrudDataGrid">
          <div className="vupFacilityWrap">
            <div className="vupFacilityLeft">
              <ul>
                {fetchFacList.map((item) => (
                  <li
                    key={item.facNo}
                    className={selected.facNo == item.facNo ? "on" : ""}
                  >
                    <Button
                      name="facNo"
                      value={item.facNo}
                      onClick={onChangeDatas}
                    >
                      {item.facDescr}
                    </Button>
                  </li>
                ))}
              </ul>
            </div>
            <div className="vupFacilityRight">
              <div className="vupFacilityTitle">
                <strong>현재상태</strong>
              </div>
              <div className="vupFacilityNow">
                <div class="vupSensorWrap">
                  <div>
                    <div class="vupFacilityTitle">
                      <b>센서진단</b>
                    </div>
                    {getFacilityNowHtml()}
                  </div>
                  <div>
                    <div class="vupFacilityTitle">
                      <b>운전패턴 진단</b>
                    </div>
                    {chartLineYn ? (
                      <UI_3_5_ChartLine data={selectedTagGraphData} />
                    ) : (
                      <UI_3_5_ChartScatter data={selectedTagGraphData} />
                    )}
                  </div>
                  <dl>
                    <dt>
                      이상알람
                      {!alarmData || (
                        <FxOpenButton
                          title={"조치실적 등록"}
                          opObj={opObjAdd}
                          selectedData={alarmData}
                          className="fpactButton"
                        />
                      )}
                    </dt>
                    <dd>
                      {alarmData
                        ? alarmData.alarmMsg + getDateHtml(alarmData.occurDtm)
                        : "알람 데이터 없음"}
                    </dd>
                  </dl>
                  <dl>
                    <dt>수명예측</dt>
                    <dd>
                      수명한계
                      <p style={{ marginLeft: "16px", display: "inline" }}>
                        {fetchDataState.alarmLifeDtm}
                      </p>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer>
          <div>Virtual Utility Plant</div>
          <div>Copyright 2022 VUP All rights reserved</div>
        </footer>
      </div>
    </>
  );
};
